<template>
  <section class="global-box">
    <div class="content-box">
      <h2>Nossos serviços</h2>
      <p>
        Atuamos com uma gama de serviços que auxilia o seu negócio
        a passar pelo fenômeno de transformação digital, marcando
        presença também na internet, uma ferramenta importante para
        que o seu negócio continue prosperando e tenha cada vez mais
        visibilidade.
      </p>
      <section class="content-services">
        <div v-for="(item, index) in services" :key="index" class="unitary">
          <icon :description="item.icon" size="60" />
          <h3>{{item.title}}</h3>
          <p>{{item.description}}</p>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
export default {
  name: 'services-section',
  props: {
    complete: {
      type: Boolean,
      default: true,
    },
    isFlutuation: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      flutuation: false,
      services: [
        {
          title: 'website institucional',
          description: `Desenvolvimento de site institucional para que sua empresa
          esteja presente e possa ser encontrada na internet;`,
          icon: 'icon-website',
        },
        {
          title: 'landig pages',
          description: `Páginas com a finalidade de conversão de lead's de interessados
          em seus produtos / serviços;`,
          icon: 'icon-landing-page',
        },
        {
          title: 'sistemas gerenciais',
          description: `Elaboração de sistemas gerenciaveis personalizado de acordo
          com a necessidade de seu negócio;`,
          icon: 'icon-systems',
        },
        {
          title: 'Conteúdo para redes sociais',
          description: `Elaboração de conteúdos publicitários para que o seu 
          produto e serviço esteja presente nas redes sociais;`,
          icon: 'icon-social-media',
        },
        {
          title: 'E-mail marketing',
          description: `Elaboração de conteúdos publicitários para que seja distribuído
          à sua lista de contatos;`,
          icon: 'icon-mail-mkt',
        },
      ],
    };
  },
  methods: {
    updateScroll() {
      if (this.isFlutuation) {
        if (window.scrollY > 120) {
          this.flutuation = true;
        } else {
          this.flutuation = false;
        }
      }
    },
    routerDirect() {
      if (this.$router.currentRoute.path !== '/') {
        this.$router.push({ path: '/' });
      }
    },
  },
};
</script>

<style lang="sass" scoped>
  @import "../assets/sass/main.sass"
  > section
    width: 100%
    height: 700px
  .global-box
    .content-services
      display: flex
      flex-wrap: wrap
      justify-content: space-evenly
      padding-top: 32px
      .unitary
        width: 30%
        padding: 12px 32px 40px
        display: flex
        flex-wrap: wrap
        justify-content: center
        p
          text-align: center
        svg
          fill: $grey-900
          margin-bottom: 16px
    @media (max-width: $widthTerciarySmall)
      p
        text-align: justify
      .content-services
        .unitary
          width: 100%
</style>
